import { RelatedPeopleStatus } from '@shared/constants/constants';
import type { RelatedPersonProfile } from '@shared/services/caregivers/types/getRelatedPeople.types';

const isCaregiversHasActionRequired = (caregiversList: RelatedPersonProfile[]) =>
  caregiversList?.some((caregiver) => !caregiver.IsMyChartSync && caregiver.Status === RelatedPeopleStatus.APPROVED);

export default isCaregiversHasActionRequired;
